var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Notifications White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Notifications-White",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_notifications_white_24px",
    transform: "translate(10.416667, 6.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625,39.0625 C17.7734375,39.0625 19.53125,37.2596154 19.53125,35.0560897 L11.71875,35.0560897 C11.71875,37.2596154 13.4570313,39.0625 15.625,39.0625 Z M27.34375,27.0432692 L27.34375,17.0272436 C27.34375,10.8774038 24.140625,5.72916667 18.5546875,4.36698718 L18.5546875,3.00480769 C18.5546875,1.34214744 17.2460938,0 15.625,0 C14.0039062,0 12.6953125,1.34214744 12.6953125,3.00480769 L12.6953125,4.36698718 C7.08984375,5.72916667 3.90625,10.8573718 3.90625,17.0272436 L3.90625,27.0432692 L0,31.0496795 L0,33.0528846 L31.25,33.0528846 L31.25,31.0496795 L27.34375,27.0432692 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notification-white.0661db9851af628f4219a37b3d665737.svg";
export { ForwardRef as ReactComponent };